<template>
<div class="header">

    <div class="header-logo">
        <img :src="'./mp-logo.png'" style="width: 130px;" />
    </div>
    <div class="header-left">
        <label>Fraktavtale</label>
    </div>

    <div class="header-right">

        <div class="header-item" v-if="allowSK" @click="onSKClicked">
            <label v-if="$parent.$parent.skEnabled">Bytt til vanlig versjon</label>
            <label v-if="!$parent.$parent.skEnabled">Bytt til storkunde-versjon</label>
        </div>
        <div class="header-item" @click="onHelpClicked">
            <label>Hjelp</label>
        </div>

    </div>

</div>
</template>
<script>

export default {
name: 'Header',
props: {
    allowSK: {
        type: Boolean,
        default: false
    }
},
data() {
    return {
        
    }
},
methods: {
    onHelpClicked() {
        this.$parent.$parent.showHelp = true;
    },
    onSKClicked() {
        this.$parent.$parent.skEnabled = !this.$parent.$parent.skEnabled;
    }
}
}
</script>
<style scoped>

.header {
    display: flex;
    width: 100%;
    height: 60px;
    background-color: white;
}

.header-logo {
    padding-top: 10px;
    padding-left: 24px;
}

.header-left {
    flex-grow: 100;
    padding-top: 15px;
    padding-left: 20px;
}
.header-left label {
    font-size: 24px;
}

.header-right {
    float: right;
    display: flex;
}

.header-item {
    height: 24px;
    margin-top: 19px;
    margin-right: 30px;
    cursor: pointer;
}
.header-item:hover {
    opacity: 0.6;
}
.header-item label {
    font-size: 18px;
    cursor: pointer;
}

</style>
